import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Iconify from "src/components/iconify";

import { t } from "i18next";

import AuthLoginLayout from "src/layouts/auth/login";
import IconButton from "@mui/material/IconButton";
import { JwtLoginView } from "src/sections/auth/custom";
import { useAuthContext } from "src/auth/hooks";
import { useWhiteLabel } from "src/context/WhiteLabelContext";
import { useState } from "react";
import LoginButton from "../login-button/login-button";
// ----------------------------------------------------------------------

export default function LoginDialog({ returnTo }: { returnTo?: string }) {
  const { authenticated } = useAuthContext();
  const { currentTranslation, portal } = useWhiteLabel();
  const [open, setOpen] = useState(false);
  const loginContent = currentTranslation?.block_content.login ?? {};
  const loginFeatures = [1, 2, 3].map((index) => ({
    title: loginContent[`feature_${index}_title`],
    description: loginContent[`feature_${index}_body`],
  }));

  if (authenticated) return null;

  return (
    <>
      <LoginButton onClick={() => setOpen(true)} />

      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        scroll="body"
        keepMounted={false}
        disableRestoreFocus
      >
        <AuthLoginLayout
          image={portal?.brand.login_background_url}
          title={loginContent.title}
          features={portal ? loginFeatures : undefined}
        >
          <DialogTitle>{t("login")}</DialogTitle>

          <IconButton
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              m: 1,
              color: "black",
            }}
            edge="end"
            onClick={() => setOpen(false)}
          >
            <Iconify icon="mingcute:close-line" />
          </IconButton>

          <DialogContent sx={{ background: "white" }}>
            <JwtLoginView onClose={() => setOpen(false)} returnTo={returnTo} />
          </DialogContent>
        </AuthLoginLayout>
      </Dialog>
    </>
  );
}
